<template>
  <div class="hello">
    <div v-html="html"  v-highlight class="content"></div>
  </div>
</template>
 
<script>
import showdown from "showdown";
import readme from "../../static/markdown/1.md";
export default {
  data() {
    return {
      md: readme,
      html: ""
    };
  },
  components: {
    showdown
  },
  mounted() {
    let converter = new showdown.Converter();
    let text = this.md.toString();
    this.html = converter.makeHtml(text);
  }
};
</script>
 
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue